<div class="d-flex flex-column flex-root">
  <div class="page d-flex flex-row flex-column-fluid">
    <div class="wrapper d-flex flex-column flex-row-fluid ps-0" id="qrpay_wrapper">
      <app-header
        [showMenu]="false"
        id="qrpay_header"
        [ngClass]="headerCSSClasses"
        class="header align-items-stretch no-stretch-header"
        #ktHeader
      ></app-header>
      <div id="qrpay_content" class="content d-flex flex-column flex-column-fluid">
        <!--<ng-container *ngIf="toolbarDisplay">
          <app-toolbar class="toolbar" id="qrpay_toolbar"></app-toolbar>
        </ng-container>-->
        <div class="post d-flex flex-column-fluid" id="qrpay_post">
          <app-content
            id="qrpay_content_container"
            [ngClass]="contentContainerClasses"
          ></app-content>
        </div>
      </div>

    </div>
  </div>
</div>

<app-scripts-init></app-scripts-init>
<app-scroll-top></app-scroll-top>

<!--
 begin:: Drawers
<app-activity-drawer></app-activity-drawer>
<app-messenger-drawer></app-messenger-drawer>
 end:: Drawers
-->
